import axios from 'axios'
import { getAdminToken, getCustomerToken, getSuperAdminToken } from './function'

export const baseURL = 'http://127.0.0.1/projects/whatsappapinew/api'

export const api = axios.create({ baseURL: baseURL })

export const customerReqConfig = () => ({
    headers: {
        Authorization: getCustomerToken()
    },
})

export const adminReqConfig = () => ({
    headers: {
        Authorization: getAdminToken()
    },
})

export const superAdminReqConfig = () => ({
    headers: {
        Authorization: getSuperAdminToken()
    },
})